import CONFIG from '@/config';
import { CustomHttpClient, CustomRMAHttpClient, RawHttpClient } from '@/modules/HttpClient';
import * as Client from '@reolink-deps/reolink_web.fe.http-client';
import getGlobal from '@/utils/shared/getGlobal';
const client = new CustomHttpClient(`${CONFIG.official}/wp-json/reo-v2`);
const clientRMA = new CustomRMAHttpClient(`${CONFIG.api}/v2/rma`);
const clientApisV2 = new CustomHttpClient(`${CONFIG.api}/v2`);
const clientApisV2Rma = new CustomRMAHttpClient(`${CONFIG.rmaApi}/v2/rma`);
const clientApisV1 = new CustomHttpClient(`${CONFIG.api}/v1.0`);

const clientOut = (url: string): CustomHttpClient => {
    return new CustomHttpClient(url);
};
export const officialServerClient = new CustomHttpClient(`${CONFIG.api}/v2/official-site-data-cache`);

export const rpcCacheClient = new RawHttpClient({
    baseUrl: CONFIG.rpcCache
});

export const dealsCacheClient = new RawHttpClient({
    baseUrl: CONFIG.dealsCache
});
const clientApisV2UseData = new CustomHttpClient(`${CONFIG.api}/v2`, {
    isReceivingResponseUseData: true,
});

export async function requestRpc<T=unknown>(
    client: RawHttpClient,
    service: string, data?: Array<Record<string, unknown>>): Promise<T> {
    if (!process.env.isSSR) {
        console.debug(`API Called: ${service}. Data: ${JSON.stringify(data)}`);
        console.time(`API Spent: ${service}`);
    }

    try {
        const ret = await client.post<T>('', {
            api: service,
            args: data ?? []
        });
        return ret;

    }
    catch (error) {
        console.error(error);
        throw error;
    }
    finally {
        if (!process.env.isSSR) {
            console.timeEnd(`API Spent: ${service}`);
        }
    }
}

class ClientFactory {
    public method: Client.HttpClient;

    public constructor() {
        this._init();
    }

    private _init(): void {
        const session = getGlobal().document ? new Client.Session({
            clientId: CONFIG.clientId,
            cookieDomain: CONFIG.official,
            handleLogin: () => undefined,
            baseUrl: `${CONFIG.api}/v1.0`,
        }) : undefined;
        this.method = new Client.HttpClient({
            baseUrl: `${CONFIG.api}/v2`,
            timeout: 10000,
            sessionInstance: session,
            receivingResponse: {
                onFulfilled: (response) => {
                    return response.data;
                }
            }
        });
    }

}

const clientApi: ClientFactory = new ClientFactory() ;

export { client, clientApi,  clientRMA, clientApisV2, clientApisV2Rma, clientOut, clientApisV2UseData, clientApisV1 };
